<template>
    <div class="institution" id="institution">
        <div class="content" v-for="(service,index) in services" :key="index">
            <img src="../assets/subtitle/bar.png">
            <p class="bigText">{{service.Btext}}</p>
            <span class="smallText">{{service.Stext1}}</span><br>
            <span class="smallText">{{service.Stext2}}</span><br>
            <img id="show" :src="service.pic">
        </div>
    </div>
</template>

<script>
export default {
    name: 'institutionSubtitleService',
    data () {
        return {
            services: [
                {
                    Btext: '智能字幕速记系统',
                    Stext1: '可以将发言人所说的话实时转化为文字显示在屏幕上，并支持在线编辑',
                    Stext2: '应用领域：特殊教育学校、会议场景、企业、政府机构',
                    pic: require('../assets/subtitle/shorthand.png')
                },
                {
                    Btext: '无障碍沟通系统',
                    Stext1: '面向机构提供字幕、手语、听力服务，打造无障碍沟通环境',
                    Stext2: '应用领域：普通学校（含听障学生）、企业（含听障员工）、政务机关（服务群体包含听障人员）',
                    pic: require('../assets/subtitle/communication.png')
                }
            ]
        }
    }
}
</script>

<style scoped>
.institution{
    text-align: center;
}
.bigText{
    font-size:3em;
    font-weight: 450;
}
.smallText{
    font-size:2em;
    font-weight: 300;
    letter-spacing: 1px;
    color: gray;
    line-height: 1.8;
}
.content{
    padding:12% 0 0;
}
#show{
    width:75%;
    height:auto;
    margin-top:6%;
}
@media screen and (max-width:1200px){
    .bigText{
        font-size: 2.5em;
    }
    .content p{
        line-height: 15%;
    }
    .smallText{
        font-size:1.8em;
        line-height: 1.5
    }
}
@media screen and (max-width:1000px){
    .bigText{
        font-size: 2.3em;
    }
    .smallText{
        font-size:1.3em;
        line-height: 1.2;
    }
}
@media screen and (max-width:650px){
    .bigText{
        font-size: 2em;
    }
    .smallText{
        font-size:1em;
        line-height: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/institutionSubtitleService.vue